import { any, number, string } from 'prop-types'
import styled from 'styled-components'
import { TextStyle } from '../../../../../components/Ui-Kits/Text'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const IconText = ({ color, icon, text, mt, mb }) => {
  return (
    <Text color={color} mt={mt} mb={mb}>
      <Icon icon={icon} />
      {text}
    </Text>
  )
}

IconText.propTypes = {
  color: ['primary', 'black'],
  icon: any,
  text: string,
  mt: number,
  mb: number,
}

const Text = styled.div`
  ${TextStyle}
  margin-top: ${({ mt }) => mt ?? 0.5}rem;
  margin-bottom: ${({ mb }) => mb ?? 0.5}rem;
`
const Icon = styled(FontAwesomeIcon)`
  margin-right: 0.31rem;
`
